/*
*	Ordre de tabulation des factures: Tab et Maj+Tab suivent les parcours ci-dessous
*	plutôt que l'ordre du document. Hors d'un parcours, Tab garde son comportement normal.
*/
var TabOrder = {

	// Chaque parcours: un conteneur et ses étapes, résolues au moment de la touche.
	// Un sélecteur qui touche plusieurs lignes donne une étape par champ, dans l'ordre du document.
	flows: [
		// Nouvelle facture: destinataire, champs de facturation, référence, puis Sauvegarder
		{
			container: 'body',
			when: function(){ return $('.slr-form input[name=action]').val() == 'add'; },
			steps: ['#field-contact_id', '#field-invoiced', '#field-att', '#field-reference', function(){ return $('.btn-action-submit'); }]
		},
		// Cachet (publicité)
		{
			container: '.slr-fee-tab',
			steps: [
				'input[name=nb_annonces]',
				'input[name=apc_tableau]',
				'input[name=circuit]',
				'input[name=use]',
				'input[name=use2]',
				'input[name=inm_diffusion]',
				'input[name=role]',
				'input[name=cond_percent]',
				'input[name=cond_diff_percent]',
				'input[name=cycle]',
				'select[name=duration]',
				'select[name=inm_duration]',
				'input[name=cycle_date1]',
				'input[name=cycle_date2]',
				'button[data-action=next-tab]'
			]
		},
		// Garanties et cachet (autre)
		{
			container: '.slr-guarantees-tab',
			steps: ['select[name=fonction]', 'input[name=jours_tournage]', 'input[name=emissions_episodes]', 'input[name=droits_percent]', 'input[name=cachet]', 'button[data-action=next-tab]']
		},
		// Lignes de garanties, puis Ajouter
		{
			container: '.slr-guarantees-tab',
			steps: ['.repeater-field__rows select[name=guarantee_item], .repeater-field__rows input[name=guarantee_number]', '.repeater-field__add', 'button[data-action=next-tab]']
		},
		// Détails: type, dates, lignes, puis +
		{
			container: '.slr-details-tab',
			steps: [
				'select[name=element_type]',
				'input[name=date1]',
				'input[name=date2]',
				'.slr-details-item-container select[name=item_type], .slr-details-item-container textarea[name=description], .slr-details-item-container input[name=value]',
				'.btn-action-add-details'
			]
		},
		// Contrat: le bouton Suivant
		{
			container: '.slr-contract-tab',
			steps: ['button[data-action=next-tab]']
		},
		// Édition de facture: la redevance mène à l'onglet ouvert de l'élément
		{
			container: 'body',
			when: function(){ return $('.slr-form input[name=action]').val() == 'edit'; },
			steps: ['#field-redevance', function(){ return TabOrder.openTabEntry(); }]
		}
	],

	// Champ qui reçoit vraiment le focus: la boîte select2, le bouton bootstrap-select ou le bouton radio coché
	target: function(el, container)
	{
		var $el = $(el);
		if ($el.is('select') && $el.next('.select2').length){
			return $el.next('.select2').find('.select2-selection')[0];
		}
		if ($el.is('select') && $el.closest('.bootstrap-select').length){
			return $el.closest('.bootstrap-select').find('button.dropdown-toggle')[0];
		}
		if ($el.is(':radio')){
			var group = $(container).find('input[type=radio][name="' + el.name + '"]').filter(':visible');
			return group.filter(':checked')[0] || group[0];
		}
		return el;
	},

	// Étapes d'un parcours: [{focus, members}], sans les champs cachés ou désactivés
	resolve: function(flow, container)
	{
		var steps = [];
		flow.steps.forEach(function(step){
			var found = (typeof step === 'function') ? step() : $(step, container);
			var radios = {};
			$(found).each(function(){
				if ($(this).is(':radio')){
					if (radios[this.name]){ return; }
					radios[this.name] = true;
				}
				var focus = TabOrder.target(this, container);
				if (!focus || !$(focus).is(':visible') || $(focus).is(':disabled')){ return; }
				var members = $(this).is(':radio') ? $(container).find('input[type=radio][name="' + this.name + '"]').get() : [focus];
				steps.push({ focus: focus, members: members });
			});
		});
		return steps;
	},

	// Premier champ de l'onglet ouvert de l'élément sélectionné
	openTabEntry: function()
	{
		var tab = $('.slr-el.selected .card-collapse.show .card-block').first();
		return tab.length ? TabOrder.firstStep(tab) : $();
	},

	firstStep: function(tab)
	{
		for (var i = 0; i < TabOrder.flows.length; i++){
			var flow = TabOrder.flows[i];
			if (!flow.when && tab.is(flow.container)){
				var steps = TabOrder.resolve(flow, tab);
				if (steps.length){ return $(steps[0].focus); }
			}
		}
		return $();
	},

	// Donne le focus à un champ; le texte d'une case est sélectionné pour être tapé par-dessus
	focus: function(el)
	{
		$(el).focus();
		if ($(el).is('input[type=text], input:not([type])')){
			el.select();
		}
	},

	// Donne le focus au premier champ d'un onglet, une fois ouvert
	focusTab: function(tab)
	{
		var first = TabOrder.firstStep($(tab).find('.card-block').first());
		if (first.length){
			TabOrder.focus(first[0]);
		}
	},

	// Étapes du parcours qui contient ce champ et sa position, ou null hors parcours
	locate: function(el)
	{
		for (var i = 0; i < TabOrder.flows.length; i++){
			var flow = TabOrder.flows[i];
			var container = $(el).closest(flow.container);
			if (!container.length || (flow.when && !flow.when())){ continue; }
			var steps = TabOrder.resolve(flow, container);
			var index = steps.findIndex(function(step){ return step.members.indexOf(el) >= 0; });
			if (index >= 0){ return { steps: steps, index: index }; }
		}
		return null;
	},

	// Vrai entre un Enter dans une liste select2 ouverte et sa fermeture
	select2Enter: false,

	// Après un choix dans une liste: passe au champ suivant, sauf si le focus a déjà été placé ailleurs
	advance: function(select)
	{
		var from = TabOrder.target(select);
		var active = document.activeElement;
		if (active && active !== document.body && active !== from){ return; }
		var found = TabOrder.locate(from);
		var next = found && found.steps[found.index + 1];
		if (next){
			TabOrder.focus(next.focus);
		}
	},

	keydown: function(e)
	{
		if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey){ return; }
		var found = TabOrder.locate(document.activeElement);
		var next = found && found.steps[found.index + (e.shiftKey ? -1 : 1)];
		if (next){
			e.preventDefault();
			TabOrder.focus(next.focus);
		}
	},

	// bootstrap-select 1.12 suit Bootstrap 3: sous Bootstrap 4, sa liste ouverte ne répond ni aux flèches ni à Enter.
	// Capté avant les deux librairies: les flèches parcourent les options, Enter ou Espace choisit, Échap referme.
	selectpickerKeydown: function(e)
	{
		var option = $(e.target).filter('.bootstrap-select [role=listbox] li > a');
		if (!option.length){ return; }
		var picker = option.closest('.bootstrap-select');
		var options = picker.find('[role=listbox] li').not('.disabled, .hidden, .dropdown-header, .divider').children('a');
		var index = options.index(option);
		if (e.key === 'ArrowDown' || e.key === 'ArrowUp'){
			options.eq(Math.max(0, Math.min(options.length - 1, index + (e.key === 'ArrowDown' ? 1 : -1)))).focus();
		} else if (e.key === 'Enter' || e.key === ' '){
			option[0].click();
			TabOrder.advance(picker.find('select')[0]);
		} else if (e.key === 'Escape'){
			picker.find('.dropdown-toggle').trigger('click').focus();
		} else {
			return;
		}
		e.preventDefault();
		e.stopPropagation();
	}
};

$(document).on('keydown', TabOrder.keydown);
document.addEventListener('keydown', TabOrder.selectpickerKeydown, true);

// Choix fait dans une liste select2, au clic ou au clavier: le focus suit au champ suivant.
// Rechoisir la valeur en place avec Enter ferme la liste sans choix: le focus suit aussi.
// Délai: les gestionnaires propres au champ et la fermeture de select2 passent d'abord.
document.addEventListener('keydown', function(e){
	if (e.key === 'Enter' && $('.select2-container--open').length){ TabOrder.select2Enter = true; }
}, true);
$(document).on('select2:select', function(e){
	setTimeout(function(){ TabOrder.advance(e.target); }, 0);
}).on('select2:close', function(e){
	var enter = TabOrder.select2Enter;
	TabOrder.select2Enter = false;
	setTimeout(function(){
		if (enter && document.activeElement === document.body){ TabOrder.advance(e.target); }
	}, 0);
});
